// @ts-check
import RequestService from '../../../services/request-service';

/**
 * Live Channel Online Request Service
 */
export default class LiveChannelOnlineRequestService extends RequestService {
  /**
   * Class constructor method
   * @param {import('../../../models/livestream/livestream.const').TSTREAM_PROVIDERS_VALUES} providerId - stream provider id
   */
  constructor(providerId = 1) {
    super();
    this.endpoint = this.$config.endpoints.liveChannelOnline;
    this.method = 'get';
    const getParams = {
      StreamingIntegrationBrokerId: providerId,
      LiveOnly: true,
    };
    /**
     * @type {typeof getParams}
     */
    this.getParams = getParams;
    this.headers = null;
  }
}
